import { createSignal } from "solid-js";
import { twMerge } from "tailwind-merge"
import { CustomLoader } from "../components/CustomLoader";

export const AddToBagButton = (props) => {
  const [loading, setLoading] = createSignal(false);

  const handleAddToBagClick = async () => {
    setLoading(true);
    await props.handleAddToBagClick();
    setLoading(false);
  }

  return (
    <div
      id={props.id}
      class={
        twMerge(
          "",
          props.class ?? ""
        )
      }
    >
      <button
        type="button"
        id="add-to-bag"
        onClick={handleAddToBagClick}
        class={
          twMerge(
            "w-full font-bold p-2 border border-solid grow text-base hover:catalog-bg-light-color bg-tertiary-500 text-canvas flex justify-center items-center rounded-lg max-w-sm hover:text-canvas-light",
            props.buttonClass ?? ""
          )
        }
      >
        {loading()
          ? CustomLoader('#000')
          : props.buttonText ?? `Add to bag`}
      </button>
    </div>
  )
}

export const NeumorphicAddToBagButton = (props) => {
  const [loading, setLoading] = createSignal(false);

  const handleAddToBagClick = async () => {
    setLoading(true);
    await props.handleAddToBagClick();
    setLoading(false);
  }

  return (
    <button
      type="button"
      id={`${props.id}`}
      onClick={handleAddToBagClick}
      class={
        twMerge(
          "w-full bg-ink font-bold shadow-[-4px_-4px_0_0_#0B3E16_inset] py-2 px-6 hover:shadow-none text-canvas",
          props.buttonClass ?? ""
        )
      }
    >
      {loading()
        ? CustomLoader('#000')
        : props.buttonText ?? `Add to bag`}
    </button>
  )
}